/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import fontUtils from 'js-sdk/src/common/util/fontUtils';
import getHCConfigPropertyKey from './getHCConfigPropertyKey';

const getPlotOffsets = (formattingOptions :any) => {

    // this is a plot offsets, they work like padding for chart area, but I call them offsets
    const plotOffsets = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    };

    // we support adding few titles to the chart, like 'title.text' and 'subtitle.text'
    // the support means we give some extra space above the chart to fix them

    let hasTitle = false;
    let hasSubTitle = false;

    const titleSetting = getHCConfigPropertyKey(formattingOptions, 'title.text');
    if (titleSetting) {
        // the default font size which is the same as HC has
        let fontSize = 18;

        // check if user has supplied a font size
        const fontSizeFromUser = getHCConfigPropertyKey(formattingOptions, 'title.style.fontSize');
        if (fontSizeFromUser) {
            const parsedFontSize = parseInt(fontSizeFromUser, 10);
            if (parsedFontSize) {
                fontSize = parsedFontSize;
            }
        }

        const fontHeight = fontUtils.getFontHeight(fontSize);
        plotOffsets.top += fontHeight;
        hasTitle = true;
    }

    const subTitleSetting = getHCConfigPropertyKey(formattingOptions, 'subtitle.text');
    if (subTitleSetting) {
        // the default font size which is the same as HC has
        let fontSize = 11;

        // check if user has supplied a font size
        const fontSizeFromUser = getHCConfigPropertyKey(formattingOptions, 'subtitle.style.fontSize');
        if (fontSizeFromUser) {
            const parsedFontSize = parseInt(fontSizeFromUser, 10);
            if (parsedFontSize) {
                fontSize = parsedFontSize;
            }
        }

        const fontHeight = fontUtils.getFontHeight(fontSize);
        plotOffsets.top += fontHeight;
        hasSubTitle = true;
    }

    // if title or subtitle are present then increase top offset more
    if (hasTitle || hasSubTitle) {
        plotOffsets.top += 10;
    }

    return plotOffsets;
};

export default getPlotOffsets;
